module.exports = __webpack_public_path__ + "static/media/10.ef4a88d3.jpg";